const tool: { [key: string]: any } = {}

tool.local = {
  get(key: string) {
    let data = localStorage.getItem(key)
    try {
      data = JSON.parse(data)
    } catch (err) {
      return data
    }
    return data
  },
  set(key: string, value: string) {
    const data = JSON.stringify(value)
    localStorage.setItem(key, data)
  },
  remove(key: string) {
    localStorage.removeItem(key)
  },
  clear() {
    localStorage.clear()
  }
}

tool.tree = (data: any, pid = 0, key = 'pid') => {
  const result = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const i in data) {
    if (data[i][key] === pid) {
      const temp = data[i];
      const children = tool.tree(data, data[i].id, key);
      if (children.length) {
        temp.children = children;
      }
      result.push(temp);
    }
  }

  return result;
}


export default tool
